export default __webpack_public_path__ + "static/media/spotShareButton.ee7b8356.svg";